
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "data-privacy-request-ui",
  currentProjectVersion: "static-1.6005",
  depVersions: {
  "data-privacy-request-ui": "static-1.6005",
  "client-types": "static-1.511",
  "data-fetching-client": "static-1.10122",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8519",
  "hub-http-shared-msw-handlers": "static-1.10916",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11968",
  "I18n": "static-7.1708",
  "jasmine-runner": "static-1.6933",
  "quartz": "static-1.7665",
  "react-dlb": "static-1.93",
  "rpc-client-utils": "static-1.5151",
  "ui-components-test-utils": "static-1.6105",
  "UIComponents": "static-3.8914",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.99",
  "foundations-assets": "static-1.5367",
  "foundations-components": "static-1.8758",
  "foundations-components-test-utils": "static-1.6241",
  "foundations-theming": "static-1.4969",
  "hub-http": "static-1.6688",
  "hubspot-url-utils": "static-1.4383",
  "quartz-config": "static-1.1443",
  "quartz-core": "static-1.6884",
  "quartz-routing": "static-1.1095",
  "quartz-tracking": "static-1.1044",
  "quick-fetch": "static-1.4234",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-rhumb": "static-1.17218",
  "SharedI18nStrings": "static-1.187",
  "ui-addon-i18n": "static-1.11626",
  "usage-tracker-core": "static-1.7656",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3942",
  "quartz-webpack": "static-1.3889",
  "bend-plugin-quartz-routing": "static-1.743",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.93",
  "HeadJS": "static-2.822",
  "framer-motion": "static-1.84",
  "hs-test-utils-bend-plugin": "static-1.3630",
  "msw": "static-1.103",
  "msw-config": "static-1.29",
  "testing-library": "static-1.164",
  "ts-schema": "static-1.4397",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.96",
  "react-utils": "static-2.5659",
  "StyleGuideUI": "static-3.518",
  "jasmine": "static-4.4788",
  "bend-plugin-chirp-manifest": "static-1.561",
  "chirp-fetch": "static-1.2386",
  "HubStyle": "static-2.12275",
  "ui-addon-draggable": "static-3.5229",
  "cssUtils": "static-1.1104",
  "hs-story-utils": "static-1.9908",
  "icons": "static-2.703",
  "react-create-root-preference": "static-1.103",
  "react-select-plus": "static-1.118",
  "react-virtualized": "static-2.112",
  "ui-images": "static-2.1277",
  "bend-plugin-foundations-components": "static-1.5027",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2685",
  "react-aria": "static-1.77",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3102",
  "ui-fonts": "static-1.1230",
  "foundations-components-legacy": "static-1.1783",
  "bend-plugin-foundations-theming": "static-1.3452",
  "foundations-theming-base": "static-1.3954",
  "stylex": "static-1.46",
  "hs-locale-management": "static-1.403",
  "opentelemetry-fe-types": "static-1.273",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.907",
  "hubspotter-http": "static-1.4978",
  "mobile-manifest-mixins": "static-1.606",
  "module-federation": "static-1.38",
  "opentelemetry-fe": "static-1.648",
  "quartz-auth": "static-1.1340",
  "quartz-head": "static-1.1330",
  "quartz-i18n": "static-1.1340",
  "quartz-test": "static-1.1340",
  "trellis-components": "static-1.3121",
  "usage-tracker-container": "static-1.7796",
  "usage-tracker-session-replay": "static-1.5492",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.182",
  "web-vitals": "static-1.19",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3600",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.83",
  "sassPrefix": "static-1.370",
  "stylex-utils": "static-1.175",
  "trellis-theming": "static-1.1488",
  "opentelemetry-web": "static-1.22",
  "hubspotter-http-shared-msw-handlers": "static-1.10914",
  "base-ui": "static-1.28",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.6005",
  "client-types": "/client-types/static-1.511",
  "data-fetching-client": "/data-fetching-client/static-1.10122",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8519",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10916",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11968",
  "I18n": "/I18n/static-7.1708",
  "jasmine-runner": "/jasmine-runner/static-1.6933",
  "quartz": "/quartz/static-1.7665",
  "react-dlb": "/react-dlb/static-1.93",
  "rpc-client-utils": "/rpc-client-utils/static-1.5151",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6105",
  "UIComponents": "/UIComponents/static-3.8914",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.99",
  "foundations-assets": "/foundations-assets/static-1.5367",
  "foundations-components": "/foundations-components/static-1.8758",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6241",
  "foundations-theming": "/foundations-theming/static-1.4969",
  "hub-http": "/hub-http/static-1.6688",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "quartz-config": "/quartz-config/static-1.1443",
  "quartz-core": "/quartz-core/static-1.6884",
  "quartz-routing": "/quartz-routing/static-1.1095",
  "quartz-tracking": "/quartz-tracking/static-1.1044",
  "quick-fetch": "/quick-fetch/static-1.4234",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-rhumb": "/react-rhumb/static-1.17218",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11626",
  "usage-tracker-core": "/usage-tracker-core/static-1.7656",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3942",
  "quartz-webpack": "/quartz-webpack/static-1.3889",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.743",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.93",
  "HeadJS": "/HeadJS/static-2.822",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3630",
  "msw": "/msw/static-1.103",
  "msw-config": "/msw-config/static-1.29",
  "testing-library": "/testing-library/static-1.164",
  "ts-schema": "/ts-schema/static-1.4397",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.96",
  "react-utils": "/react-utils/static-2.5659",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "jasmine": "/jasmine/static-4.4788",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.561",
  "chirp-fetch": "/chirp-fetch/static-1.2386",
  "HubStyle": "/HubStyle/static-2.12275",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5229",
  "cssUtils": "/cssUtils/static-1.1104",
  "hs-story-utils": "/hs-story-utils/static-1.9908",
  "icons": "/icons/static-2.703",
  "react-create-root-preference": "/react-create-root-preference/static-1.103",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-virtualized": "/react-virtualized/static-2.112",
  "ui-images": "/ui-images/static-2.1277",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5027",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2685",
  "react-aria": "/react-aria/static-1.77",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3102",
  "ui-fonts": "/ui-fonts/static-1.1230",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1783",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3452",
  "foundations-theming-base": "/foundations-theming-base/static-1.3954",
  "stylex": "/stylex/static-1.46",
  "hs-locale-management": "/hs-locale-management/static-1.403",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.273",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.907",
  "hubspotter-http": "/hubspotter-http/static-1.4978",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.606",
  "module-federation": "/module-federation/static-1.38",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.648",
  "quartz-auth": "/quartz-auth/static-1.1340",
  "quartz-head": "/quartz-head/static-1.1330",
  "quartz-i18n": "/quartz-i18n/static-1.1340",
  "quartz-test": "/quartz-test/static-1.1340",
  "trellis-components": "/trellis-components/static-1.3121",
  "usage-tracker-container": "/usage-tracker-container/static-1.7796",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5492",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.182",
  "web-vitals": "/web-vitals/static-1.19",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3600",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.83",
  "sassPrefix": "/sassPrefix/static-1.370",
  "stylex-utils": "/stylex-utils/static-1.175",
  "trellis-theming": "/trellis-theming/static-1.1488",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10914",
  "base-ui": "/base-ui/static-1.28",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
